import React,{ useState, useEffect } from 'react';
import { FormControl } from '@material-ui/core';
import { CustomLabel, CustomTextField }  from "@tracknme/material-ui";
import { ViacepApi } from '../../services/Apis';
import { useDispatch, useSelector } from 'react-redux';
import * as Actions from '../../store/actions';
import { zipCodeMask } from '../../utils/mask';
import '../../App.css';
import '../../menu.css';

function Step4() {

  const dispatch = useDispatch();
  
  const { register,navigation } = useSelector(({register}) => register);

  const [postalCode,setPostalCode] = useState();
  const [street,setStreet] = useState();
  const [number,setNumber] = useState();
  const [city,setCity] = useState();
  const [state,setState] = useState();
  const [district,setDistrict] = useState();
  const [complement,setComplement] = useState();
  const [loadData,setLoadData] = useState(false);


  useEffect(() => {

    if(!loadData && register && register.address ){
        
        let zipCode = zipCodeMask(register.address.postalCode);

        setPostalCode(zipCode);
        setStreet(register.address.street);
        setNumber(register.address.number);
        setCity(register.address.city);
        setState(register.address.state);
        setDistrict(register.address.district);
        setComplement(register.address.complement);
        setLoadData(true)

        dispatch(Actions.setNavigation(false));
    }

  }, [loadData,register,dispatch ]);
  

  const handleChangePostalCodeValue = ({target}) => {
    const { value } = target;

    let zipCode = zipCodeMask(value)
    setPostalCode(zipCode);
  }

  const handleChangeStreetValue = ({target}) => {
    const { value } = target;
    setStreet(value);
  }

  const handleChangeNumberValue = ({target}) => {
    const { value } = target;
    setNumber(value);
  }

  const handleChangeCityValue = ({target}) => {
    const { value } = target;
    setCity(value);
  }

  const handleChangeStateValue = ({target}) => {
    const { value } = target;
    setState(value);
  }

  const handleChangeDistrictValue = ({target}) => {
    const { value } = target;
    setDistrict(value);
  }

  const handleChangeComplementValue = ({target}) => {
    const { value } = target;
    setComplement(value);
  }


  function getViaCep (){

    ViacepApi.get(postalCode)
    .then(response => {
        
        if(response && response.data){
         if(response.data.cep) setPostalCode(response.data.cep);
         if(response.data.logradouro)setStreet(response.data.logradouro);
         if(response.data.gia)setNumber(response.data.gia);
         if(response.data.localidade)setCity(response.data.localidade);
         if(response.data.uf)setState(response.data.uf);
         if(response.data.bairro)setDistrict(response.data.bairro);
         if(response.data.complemento)setComplement(response.data.complemento);
       }
      
    })
    .catch(error => {
        console.log('error ->',error)
    });
   
  }

  useEffect(() => {
    
    if(postalCode && state && city && district && street && number  ){
    
      dispatch(Actions.setNavigation(false));
      
      let _register = register ? register : {};

      if(_register){
        _register['address'] = {
          "postalCode": postalCode.replace(/\D/g, ""),
          "state": state,
          "city": city,
          "district": district,
          "street":street,
          "number": number,
          "complement": complement,
          "reference": ""
        }
      }
         
      dispatch(Actions.setRegister(_register));
      
    }else if(!navigation){
      dispatch(Actions.setNavigation(true));
    }
  }, [postalCode, state, city, district, street, number, navigation,dispatch,register,complement ]);

  

  return (
    
        <div>
            <div className="titleStep1">
                <CustomLabel id="standard-basic-data-picker" label="Complete as informações da sua empresa:" color="initial" component="h6" variant="h6" style={{fontSize:16, fontWeight:'bold', color:"#4D39E9"}} />  
            </div>
            <div className="form_top">
                    <div className="conteudoStep1">
                  <FormControl className="m-8 mb-16 flex-1 "  disabled={false}>
                    <CustomTextField id="cep_1" label="CEP:" value={postalCode}  name="cep_1" onChange={handleChangePostalCodeValue} variant="filled" placeholder="CEP" onBlur={() => getViaCep()}
                    onKeyPress={event => {
                        if (event.key === 'Enter') {
                          getViaCep()
                        }
                    }} style={{width:'15vw'}}/>  
                  </FormControl>
                  <FormControl className="m-8 mb-16 flex-1 "  disabled={false}>
                    <CustomTextField id="logradouro_1" label="Logradouro:" value={street}  name="logradouro_1" onChange={handleChangeStreetValue} variant="filled" placeholder="Logradouro" style={{width:'25vw'}}/>  
                  </FormControl>
                  <FormControl className="m-8 mb-16 flex-1 "  disabled={false}>
                    <CustomTextField id="numero_1" label="Número:" value={number}  name="numero_1" onChange={handleChangeNumberValue} variant="filled" placeholder="Número" style={{width:'15vw',minWidth:50}}/>  
                  </FormControl>
                  
            </div>
            </div>

            <div className="form_bottom">
                    <div className="conteudo_bottom">
                 <FormControl className="m-8 mb-16 flex-1 "  disabled={false}>
                    <CustomTextField id="complemento_1" label="Complemento:" value={complement}  name="complemento_1" onChange={handleChangeComplementValue} variant="filled" placeholder="Complemento" style={{width:'15vw',minWidth:50}}/>  
                  </FormControl>
                  <FormControl className="m-8 mb-16 flex-1 "  disabled={false}>
                    <CustomTextField id="district_1" label="Bairro:" value={district}  name="district_1" onChange={handleChangeDistrictValue} variant="filled" placeholder="Bairro" style={{width:'15vw'}}/>  
                  </FormControl>
                  <FormControl className="m-8 mb-16 flex-1 "  disabled={false}>
                    <CustomTextField id="state_4" label="Estado:" value={state}  name="state_4" onChange={handleChangeStateValue} variant="filled" placeholder="Estado" style={{width:'15vw'}}/>  
                  </FormControl>
                  <FormControl className="m-8 mb-16 flex-1 "  disabled={false}>
                    <CustomTextField id="city_1" label="Cidade:" value={city}  name="city_1" onChange={handleChangeCityValue} variant="filled" placeholder="Cidade" style={{width:'15vw'}}/>  
                  </FormControl>
                 
            </div>
             </div>
                   
        </div>
  );
}

export default Step4;

